import styled from 'styled-components'

import { CheckRegularIcon, XmarkRegularIcon } from '@components/ui/svgIcons'

import type { CopyFeedbackStatus } from './useCopyFeedback'
import { COPY_FEEDBACK_STATUS } from './useCopyFeedback'

const StyledXmarkRegularIcon = styled(XmarkRegularIcon)`
  color: ${({ theme }) => theme.colors.error[150]};
`

interface CopyFeedbackIconProps {
  /** Rendered while there is no copy result to report. */
  icon: React.ReactNode
  status: Nullable<CopyFeedbackStatus>
}

export function CopyFeedbackIcon({ icon, status }: CopyFeedbackIconProps) {
  if (status === COPY_FEEDBACK_STATUS.copied) {
    return <CheckRegularIcon size={18} />
  }

  if (status === COPY_FEEDBACK_STATUS.error) {
    return <StyledXmarkRegularIcon size={14} />
  }

  return <>{icon}</>
}
